import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/gorgon/actions';

class DocSubmittedAckForm extends React.Component {
    componentWillUpdate(){
        const { gorgon } = this.props;
    
        if (gorgon.docSubmitted) {
            this.props.docSubmissionCompleted();
        }
    }

    render(){
        return (
            <div className="container">
                <div className="jumbotron centered text-center">
                    <div className="row">
                        <br />
                    </div>
                    <div className="row">
                        <h3>Project Gorgon : Document Data Extraction</h3>
                    </div>
                    <div className="row">
                        <div className="alert alert-success" role="alert">
                            Your task has been submitted successfully.
                        </div>
                    </div>
                </div>    
            </div>
        )
    }
    
}

const mapStateToProps = (state, ownProps) => {
    return {
        gorgon: state.gorgon
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      docSubmissionCompleted: () => {
         dispatch(actions.docSubmissionCompleted())  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(DocSubmittedAckForm);


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/DocSubmittedAckForm.js